<template>
  <CheckboxFilterDropdown
    icon="mdi-view-column-outline"
    label="Columns"
    :items="columnItems"
    :selected-ids="selectedColumnUlids"
    @toggle="(id, value) => $emit('toggle-column', id, value)"
    @select-all="(value) => $emit('select-all', value)"
  />
</template>

<script setup>
import { computed } from 'vue';
import CheckboxFilterDropdown from '@/components/jobArchitecture/CheckboxFilterDropdown.vue';

const props = defineProps({
  columns: {
    type: Array,
    default: () => [],
  },
  visibility: {
    type: Object,
    default: () => ({}),
  },
});

defineEmits(['toggle-column', 'select-all']);

const columnItems = computed(() => props.columns.map((col) => ({
  id: col.ulid,
  label: col.title || col.ulid,
})));

const selectedColumnUlids = computed(() => props.columns
  .filter((col) => Boolean(props.visibility[col.ulid]))
  .map((col) => col.ulid));
</script>
